import React, { useReducer, useEffect, useContext } from "react";
import moduleConfig from "./moduleConfig";
import { Card, Row, Col } from "react-bootstrap";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as yup from "yup";
import { useNavigate } from "react-router-dom";
import ModuleHeader from "../../UI/modules/views/partials/common/ModuleHeader";
import {
  createReducer,
  createInitialState,
} from "../../../reducers/module/createReducer";
import { BreadcrumbContext } from "../../../contexts/BreadcrumbContext";
import DashboardLayout from "../../UI/layouts/DashboardLayout";
import FormErrorMessage from "../../UI/errorMessages/FormErrorMessage";
import CMSFormInput from "../../UI/forms/CMSFormInput";
import BlockErrorMessage from "../../UI/errorMessages/BlockErrorMessage";
import CMSFormSelect from "../../UI/forms/CMSFormSelect";
import CMSFormRichText from "../../UI/forms/CMSFormRichText";
import CMSFormImage from "../../UI/forms/CMSFormImage";
import {
  loadDataForCreateItemGeneral,
  onSubmitGeneral,
} from "../../../helpers/ModuleHelperFunctions";
import CMSFormColor from "../../UI/forms/CMSFormColor";
import CMSFormImageWithCrop from "../../UI/forms/CMSFormImageWithCrop";
import CMSFormMultiSelect from "../../UI/forms/CMSFormMultiSelect";

const FoodCreate = () => {
  const [createState, createDispatch] = useReducer(
    createReducer,
    createInitialState
  );
  const { setBreadcrumb } = useContext(BreadcrumbContext);
  let navigate = useNavigate();

  const loadDataForCreateItem = async () => {
    await loadDataForCreateItemGeneral(
      `${moduleConfig.url}/fetch-data-for-create-item`,
      createDispatch
    );
  };

  useEffect(() => {
    loadDataForCreateItem();
    setBreadcrumb([
      moduleConfig.breadcrumbs.listing,
      moduleConfig.breadcrumbs.create,
    ]);
  }, []);
  let imageRequirement = {
    dimension: {
      width: 500,
      height: 500,
    },
    allowedExtensions: ["image/png", "image/jpg", "image/jpeg"],
    size: 1024 * 1024 * 3,
  };
  return (
    <DashboardLayout>
      {createState.status === "fetchFailed" ? (
        <BlockErrorMessage error={createState.error} />
      ) : (
        <>
          {/* {console.log(createState.data)} */}
          {createState.status !== "fetching" && (
            <>
              <ModuleHeader
                moduleTitle={`Create ${moduleConfig.singleItemTitle}`}
                moduleUrl={moduleConfig.url}
              ></ModuleHeader>

              <section className="content">
                <Card>
                  <Card.Body>
                    {createState.isLoading && (
                      <div className="overlay position-absolute containerLoading">
                        <i className="fas fa-2x fa-sync-alt fa-spin"></i>
                      </div>
                    )}
                    <Formik
                      initialValues={{
                        title: "",
                        allergens: [],
                        foodTime: "Lunch",
                        hotOrCold: "Hot",
                        vegOrNonVeg: "Non Veg",
                        file: "",
                        description: "<p>This lunch box contains:</p><p>🍛 </p><ul><li>&nbsp;<strong><ins>Ingredients </ins></strong>: </li></ul><p>🍞 </p><ul><li>&nbsp;<strong><ins>Ingredients</ins></strong> : </li></ul><p>🥣 </p><p>🍎 Selection of fresh fruits</p>",
                        nutritionalInfo: "",
                        sortOrder: "",
                        status: "1",
                      }}
                      validationSchema={yup.object({
                        title: yup
                          .string()
                          .required("Title is required.")
                          .max(120, "Title should be at most 120 characters"),
                        allergens: yup
                          .array()
                          .of(yup.string()),

                        foodTime: yup
                          .string()
                          .required("Food time is required."),
                        hotOrCold: yup.string().required(),
                        vegOrNonVeg: yup
                          .string()
                          .required("Food type is required."),
                        file: yup
                          .mixed()
                          .required("Image is required")
                          .imageTypeCheck(
                            moduleConfig.imageRequirement.allowedExtensions
                          )
                          .imageSizeCheck(moduleConfig.imageRequirement.size),
                        description: yup
                          .string(),
                        nutritionalInfo: yup.string(),
                        ingredients: yup.string(),
                        sortOrder: yup
                          .number()
                          .required("Sort order is required."),
                        status: yup.string().required("Status is required."),
                      })}
                      enableReinitialize={true}
                      validateOnChange={true}
                      validateOnBlur={true}
                      onSubmit={async (values, { resetForm }) => {
                        const formData = new FormData();
                        for (let name in values) {
                          if (name === "allergens") {
                            if (Array.isArray(values[name])) {
                              for (var i = 0; i < values[name].length; i++) {
                                formData.append(name + "[]", values[name][i]);
                              }
                            }
                          } else if (Array.isArray(values[name])) {
                            formData.append(name, JSON.stringify(values[name]));
                          } else {
                            formData.append(name, values[name]);
                          }
                        }
                        await onSubmitGeneral(
                          formData,
                          moduleConfig.url,
                          "back",
                          createDispatch,
                          navigate
                        );
                      }}
                    >
                      {(form) => (
                        <Form onSubmit={form.handleSubmit}>
                          {createState.error && (
                            <FormErrorMessage error={createState.error} />
                          )}

                          {/* {console.log(form.errors)} */}
                          <CMSFormInput
                            name="title"
                            label="Title"
                            required={true}
                            form={form}
                          />

                          <CMSFormMultiSelect
                            name="allergens"
                            label="Allergens"
                            selectionValue="value"
                            selected={form.values.allergens}
                            required={false}
                            form={form}
                            options={
                              createState.data && createState.data.allergens
                                ? createState.data.allergens
                                : []
                            }
                            displayValue="label"
                          />

                          <CMSFormSelect
                            name="foodTime"
                            label="Food Time"
                            required={true}
                            form={form}
                            options={[
                              { label: "Breakfast", value: "Breakfast" },
                              { label: "Lunch", value: "Lunch" },
                              {
                                label: "Afternoon Snack",
                                value: "Afternoon Snack",
                              },
                              { label: "Dinner", value: "Dinner" },
                            ]}
                          />
                          <CMSFormSelect
                            name="hotOrCold"
                            label="Hot Or Cold"
                            form={form}
                            required={true}
                            options={[
                              { label: "Hot", value: "Hot" },
                              { label: "Cold", value: "Cold" },
                            ]}
                          />
                          <CMSFormSelect
                            name="vegOrNonVeg"
                            label="Veg Or Non veg"
                            required={true}
                            form={form}
                            options={[
                              { label: "Veg", value: "Veg" },
                              { label: "Non Veg", value: "Non Veg" },
                            ]}
                          />
                          <CMSFormInput
                            name="ingredients"
                            label="Ingredients"
                            info="Add texts in a comma separated way"
                            required={false}
                            form={form}
                          />
                          <CMSFormRichText
                            name="description"
                            label="Description"
                            form={form}
                            required={false}
                          />

                          <CMSFormImageWithCrop
                            label="Image"
                            name="file"
                            info="Recommended dimensions 500*500"
                            aspect={1 / 1}
                            outputSize={imageRequirement.dimension}
                            form={form}
                            required={true}
                          />

                          <CMSFormInput
                            name="nutritionalInfo"
                            label="Nutritional Info"
                            info="Add texts in a comma separated way"
                            required={false}
                            form={form}
                          />

                          <CMSFormInput
                            name="sortOrder"
                            label="Sort Order"
                            form={form}
                            required={true}
                          />

                          <CMSFormSelect
                            name="status"
                            label="Status"
                            required={true}
                            form={form}
                            options={[
                              { label: "Select Status...", value: "" },
                              { label: "Enabled", value: "1" },
                              { label: "Disabled", value: "0" },
                            ]}
                          />

                          <button
                            type="submit"
                            onClick={() => form.handleSubmit}
                            className="btn btn-primary"
                          >
                            Submit
                          </button>
                        </Form>
                      )}
                    </Formik>
                  </Card.Body>
                </Card>
              </section>
            </>
          )}
        </>
      )}
    </DashboardLayout>
  );
};

export default FoodCreate;
